/* LP11 — smooth in-page CTA scrolling that clears the theme's sticky header, plus play/pause for
   section videos (paused by default when the visitor prefers reduced motion). No dependencies. */
(() => {
  if (window.__jbLp11) return;
  window.__jbLp11 = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const headerOffset = () => {
    const header = document.querySelector('sticky-header, .header-wrapper, .section-header');
    const bottom = header ? header.getBoundingClientRect().bottom : 0;
    return Math.min(Math.max(bottom, 0), 160) + 12;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('.jb-lp11 [data-jb-lp11-scroll]');
    if (!link) return;
    const id = (link.getAttribute('href') || '').replace(/^#/, '');
    const target = id && document.getElementById(id);
    if (!target) return;
    event.preventDefault();
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset();
    window.scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
    if (history.replaceState) history.replaceState(history.state, '', '#' + id);
  });

  const setPaused = (wrap, paused) => {
    const video = wrap.querySelector('video');
    const button = wrap.querySelector('[data-jb-lp11-video-toggle]');
    if (!video) return;
    if (paused) video.pause();
    else { const p = video.play(); if (p && p.catch) p.catch(() => {}); }
    wrap.classList.toggle('is-paused', paused);
    if (button) button.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
  };

  const initVideos = (scope = document) => {
    scope.querySelectorAll('.jb-lp11 [data-jb-lp11-video]').forEach((wrap) => {
      if (wrap.dataset.jbLp11Ready) return;
      wrap.dataset.jbLp11Ready = 'true';
      const video = wrap.querySelector('video');
      if (!video) return;
      video.muted = true;
      if (reduce) setPaused(wrap, true);
      const button = wrap.querySelector('[data-jb-lp11-video-toggle]');
      if (button) button.addEventListener('click', () => setPaused(wrap, !video.paused ? true : false));
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initVideos());
  else initVideos();
  document.addEventListener('shopify:section:load', (event) => initVideos(event.target));
})();
